import { IconButton, List, ListItem, ListItemIcon, makeStyles, Popover, Typography } from '@material-ui/core';
import MoreIcon from '@material-ui/icons/MoreVert';
import PublishIcon from '@material-ui/icons/Publish';
import React, { useCallback, useContext, useState } from 'react';

import { HSTableContext } from 'Common/Table/HSTable/hs-table.context';
import Toolbar from 'Common/Toolbar';

import VisibleColumnMenu from './VisibleColumnMenu';
import {
  exportNurseOperationList
} from "../../api/hs/TransactionAndLists/ProtocolsNurseOperationList/protocol-nurse-operation-list";
const BASE_URL = process.env.REACT_APP_HS_API_BASE_URL;

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1,
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
}));

export default function ToolbarNurseOperation() {
  const classes = useStyles();
  const { rawData } = useContext(HSTableContext);
  const [anchorEl, setAnchorEl] = useState<HTMLElement>(null);
  const openMenu = useCallback((e: React.MouseEvent) => setAnchorEl(e.target as HTMLElement), []);
  const closeMenu = useCallback(() => setAnchorEl(null), []);

  const exportFile = useCallback(async () => {
    await exportNurseOperationList();
    closeMenu();
  }, [closeMenu]);

  return (
    <Toolbar color="secondary">
      <Typography variant="h6" color="inherit">
        SP Protokol Listesi ( {rawData?.totalElements} )
      </Typography>
      <span className={classes.grow} />
      <div className={classes.sectionDesktop}>
        <VisibleColumnMenu />
        <IconButton color="inherit" onClick={openMenu}>
          <MoreIcon />
        </IconButton>
        <Popover anchorEl={anchorEl} anchorOrigin={{ vertical: 35, horizontal: -125 }} keepMounted open={!!anchorEl} onClose={closeMenu}>
          <List>
            <ListItem onClick={exportFile} className="cursor-pointer">
              <ListItemIcon>
                <PublishIcon fontSize="small" />
              </ListItemIcon>
              <Typography variant="inherit">Excel'e Aktar</Typography>
            </ListItem>
          </List>
        </Popover>
      </div>
    </Toolbar>
  );
}
